<template>
  <div>
    <div id="reportImage">
      <div class="top_box">
        <!-- <span style="color: #a4a4a4;"><span style="font-size: 12px;">媒体：</span>
          <van-tag type='primary' size="large" @click="clickTag(3)" color="#F4F5F7" text-color="#606060" :class="queryParams.isType === 3?'tag-click':'tag-before'">全部</van-tag>
          <van-tag type='primary' size="large" @click="clickTag(1)" color="#F4F5F7" text-color="#606060" :class="queryParams.isType === 1?'tag-click':'tag-before'">腾讯</van-tag>
          <van-tag type='primary' size="large" @click="clickTag(2)" color="#F4F5F7" text-color="#606060" :class="queryParams.isType === 2?'tag-click':'tag-before'">巨量</van-tag>
          <van-tag type='primary' size="large" @click="clickTag(4)" color="#F4F5F7" text-color="#606060" :class="queryParams.isType === 4?'tag-click':'tag-before'">快手</van-tag>
        </span> -->
        <van-popover v-model="showPopover" trigger="click" :actions="actions" @select="onSelect" @open="(amountPer.deptId || amountPer.userId)?showPopover = false:''">
          <template #reference>
            <span style="font-size: 0.4rem;color: #a4a4a4;">媒体：</span><span class="query_type">{{ activeType }}<van-icon class="query_icon_active" size="12" name="play" /></span>
          </template>
        </van-popover>
        <span class="query_time" @click="showTimePicker">{{ queryParams.dateStr }}<van-icon class="query_icon_active" size="12" name="play" /></span>
        <!-- <van-icon style="margin-left: 10px; float: right;" size="20" name="filter-o" @click="handleFilter()" /> -->
      </div>
      <div class="sectionList">
        <van-grid clickable :column-num="1" style="width: 100%">
          <van-grid-item>
            <van-tag class="describe" type="success">消耗金额</van-tag>
            <div class="th_box">
              <div class="center_first" style="margin-top: 10px;">
                <div class="Statistics_name">当日</div>
                <!-- {{amountPer.moneySingle.name.replace('合同金额','(万元)')}}
                <van-popover v-model="showPopover1" trigger="click" :offset="offset">
                  <div class="contTip">合同金额中的单次和框架金额是以合同签约日期来计算</div>
                  <template #reference>
                    <van-icon name="question-o" color="#ff976a" size="16" />
                  </template>
                </van-popover> -->
                <div class="S_num S_num_xh">{{formaterMoney(amountPer.dayConsumeMoney)}}</div>
                <div class="percent">
                  <van-icon :name="amountPer.dayConsumeRatio.toString().indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="amountPer.dayConsumeRatio.toString().indexOf('-') == -1?'#07c160':'#ee0a24'" />
                  <span class="percentage" :style="amountPer.dayConsumeRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{amountPer.dayConsumeRatio.toString().replace('-','')}}%</span>
                </div>
              </div>
              <div class="center_first">
                <div class="Statistics_name">本周</div>
                <div class="S_num S_num_xh">{{formaterMoney(amountPer.weekConsumeMoney)}}</div>
                <div class="percent">
                  <van-icon :name="amountPer.weekConsumeRatio.toString().indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="amountPer.weekConsumeRatio.toString().indexOf('-') == -1?'#07c160':'#ee0a24'" />
                  <span class="percentage" :style="amountPer.weekConsumeRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{amountPer.weekConsumeRatio.toString().replace('-','')}}%</span>
                </div>
              </div>
              <div class="center_first">
                <div class="Statistics_name">本月</div>
                <!-- <van-popover v-model="showPopover2" trigger="click" :offset="offset">
                  <div class="contTip">合同金额中的单次和框架金额是以合同签约日期来计算</div>
                  <template #reference>
                    <van-icon name="question-o" color="#ff976a" size="16" />
                  </template>
                </van-popover> -->
                <div class="S_num S_num_xh">{{formaterMoney(amountPer.moonConsumeMoney)}}</div>
                <div class="percent">
                  <van-icon :name="amountPer.moonConsumeRatio.toString().indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="amountPer.moonConsumeRatio.toString().indexOf('-') == -1?'#07c160':'#ee0a24'" />
                  <span class="percentage" :style="amountPer.moonConsumeRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{amountPer.moonConsumeRatio.toString().replace('-','')}}%</span>
                </div>
              </div>
            </div>
            <span class="describe2">单位(元)</span>
          </van-grid-item>
        </van-grid>
        <van-grid clickable :column-num="2" style="width: 100%">
          <van-grid-item>
            <van-tag class="describe" type="success">回款金额</van-tag>
            <div class="th_box">
              <div class="center" style="margin-top: 10px;">
                <span class="Statistics_name">当日</span>
                <div class="percent">
                  <van-icon :name="amountPer.dayPaymentRatio.toString().indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="amountPer.dayPaymentRatio.toString().indexOf('-') == -1?'#07c160':'#ee0a24'" />
                  <span class="percentage" :style="amountPer.dayPaymentRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{amountPer.dayPaymentRatio.toString().replace('-','')}}%</span>
                </div>
              </div>
              <div class="S_num">{{formaterMoney(amountPer.dayPaymentMoney)}}</div>
              <div class="center">
                <span class="Statistics_name">本周</span>
                <div class="percent">
                  <van-icon :name="amountPer.weekPaymentRatio.toString().indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="amountPer.weekPaymentRatio.toString().indexOf('-') == -1?'#07c160':'#ee0a24'" />
                  <span class="percentage" :style="amountPer.weekPaymentRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{amountPer.weekPaymentRatio.toString().replace('-','')}}%</span>
                </div>
              </div>
              <div class="S_num">{{formaterMoney(amountPer.weekPaymentMoney)}}</div>
              <div class="center">
                <span class="Statistics_name">本月</span>
                <div class="percent">
                  <van-icon :name="amountPer.moonPaymentRatio.toString().indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="amountPer.moonPaymentRatio.toString().indexOf('-') == -1?'#07c160':'#ee0a24'" />
                  <span class="percentage" :style="amountPer.moonPaymentRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{amountPer.moonPaymentRatio.toString().replace('-','')}}%</span>
                </div>
              </div>
              <div class="S_num">{{formaterMoney(amountPer.moonPaymentMoney)}}</div>
            </div>
          </van-grid-item>
          <van-grid-item>
            <van-tag class="describe" type="success">充值金额</van-tag>
            <div class="th_box">
              <div class="center" style="margin-top: 10px;">
                <span class="Statistics_name">当日</span>
                <div class="percent">
                  <van-icon :name="amountPer.dayRechargeRatio.toString().indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="amountPer.dayRechargeRatio.toString().indexOf('-') == -1?'#07c160':'#ee0a24'" />
                  <span class="percentage" :style="amountPer.dayRechargeRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{amountPer.dayRechargeRatio.toString().replace('-','')}}%</span>
                </div>
              </div>
              <div class="S_num">{{formaterMoney(amountPer.dayRechargeMoney)}}</div>
              <div class="center">
                <span class="Statistics_name">本周</span>
                <div class="percent">
                  <van-icon :name="amountPer.weekRechargeRatio.toString().indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="amountPer.weekRechargeRatio.toString().indexOf('-') == -1?'#07c160':'#ee0a24'" />
                  <span class="percentage" :style="amountPer.weekRechargeRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{amountPer.weekRechargeRatio.toString().replace('-','')}}%</span>
                </div>
              </div>
              <div class="S_num">{{formaterMoney(amountPer.weekRechargeMoney)}}</div>
              <div class="center">
                <span class="Statistics_name">本月</span>
                <div class="percent">
                  <van-icon :name="amountPer.moonRechargeRatio.toString().indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="amountPer.moonRechargeRatio.toString().indexOf('-') == -1?'#07c160':'#ee0a24'" />
                  <span class="percentage" :style="amountPer.moonRechargeRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{amountPer.moonRechargeRatio.toString().replace('-','')}}%</span>
                </div>
              </div>
              <div class="S_num">{{formaterMoney(amountPer.moonRechargeMoney)}}</div>
            </div>
          </van-grid-item>
        </van-grid>
      </div>
      <div class="Statistics_title">
        <span>
          <van-tag type='primary' @click="clickDay(1)" color="#F4F5F7" text-color="#606060" :class="queryParams.isDay === 1?'tag-click':'tag-before'">7天</van-tag>
          <van-tag type='primary' @click="clickDay(2)" color="#F4F5F7" text-color="#606060" :class="queryParams.isDay === 2?'tag-click':'tag-before'">15天</van-tag>
        </span>
        <span class="title_dis">消耗趋势分析</span>
        <span class="placeholder"></span>
      </div>
      <div id="main01">
        <van-empty v-if="szmjList.length === 0 || szyyList.length === 0 || otherList.length === 0" description="消耗趋势分析" />
      </div>
      <template v-if="queryParams.isType === 2">
        <div class="Statistics_title">
          <span>
            <van-tag type='primary' @click="clickDay(1)" color="#F4F5F7" text-color="#606060" :class="queryParams.isDay === 1?'tag-click':'tag-before'">7天</van-tag>
            <van-tag type='primary' @click="clickDay(2)" color="#F4F5F7" text-color="#606060" :class="queryParams.isDay === 2?'tag-click':'tag-before'">15天</van-tag>
          </span>
          <span class="title_dis">抖音AD消耗趋势分析</span>
          <span class="placeholder"></span>
        </div>
        <div id="main02">
          <van-empty v-if="dyAdYieldList.length === 0 || dyAdTravelList.length === 0 || dyAdSelfList.length === 0" description="暂无抖音AD消耗趋势分析" />
        </div>

        <div class="Statistics_title">
          <span>
            <van-tag type='primary' @click="clickDay(1)" color="#F4F5F7" text-color="#606060" :class="queryParams.isDay === 1?'tag-click':'tag-before'">7天</van-tag>
            <van-tag type='primary' @click="clickDay(2)" color="#F4F5F7" text-color="#606060" :class="queryParams.isDay === 2?'tag-click':'tag-before'">15天</van-tag>
          </span>
          <span class="title_dis">抖音千川消耗趋势分析</span>
          <span class="placeholder"></span>
        </div>
        <div id="main03">
          <van-empty v-if="dyQcYieldList.length === 0 || dyQcTravelList.length === 0 || dyQcSelfList.length === 0" description="暂无抖音千川消耗趋势分析" />
        </div>

        <div class="Statistics_title">
          <span>
            <van-tag type='primary' @click="clickCustSource(1)" color="#F4F5F7" text-color="#606060" :class="queryParams.custSource === 1?'tag-click':'tag-before'">直客</van-tag>
            <van-tag type='primary' @click="clickCustSource(2)" color="#F4F5F7" text-color="#606060" :class="queryParams.custSource === 2?'tag-click':'tag-before'">渠道</van-tag>
          </span>
          <span class="title_dis2">抖音客户消耗TOP情况</span>
          <span @click="handleShow('hn')" style="color: #333;">{{ hnVisible?'收起':'展开' }}<van-icon :class="hnVisible?'query_icon_active':'query_icon'" size="12" name="play" /></span>
        </div>
        <van-tabs v-model="hnActiveTab" @change="hnTabChange">
          <van-tab :name="1" title="自运营"></van-tab>
          <van-tab :name="2" title="走量"></van-tab>
          <van-tab :name="3" title="收量"></van-tab>
        </van-tabs>
        <div class="vant-table">
          <div v-if="hnTopList.length > 0">
            <van-cell v-for="(item,index) in hnTopList" :key="index" @click="toDetails(item)">
              <span class="span_index" v-if="hnActiveTab === 1">{{ hnVisible? index + 1 : index === 4? amountPer.hnSelfConsumeList.length : index + 1 }}</span>
              <span class="span_index" v-if="hnActiveTab === 2">{{ hnVisible? index + 1 : index === 4? amountPer.hnTravelConsumeList.length : index + 1 }}</span>
              <span class="span_index" v-if="hnActiveTab === 3">{{ hnVisible? index + 1 : index === 4? amountPer.hnYieldConsumeList.length : index + 1 }}</span>
              <span class="line_wrap">{{ item.custName }}</span>
              <div class="riyue_box">
                <div>
                  <span class="span_label">日：</span>{{ formaterMoney(item.dayMoney) }}
                  <span :style="item.dayRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{ item.dayRatio }}%</span>
                </div>
                <div>
                  <span class="span_label">月：</span>{{ formaterMoney(item.moonMoney) }}
                  <span :style="item.moonRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{ item.moonRatio }}%</span>
                </div>
              </div>
              <van-progress :percentage="item.moneyRatio" :pivot-text="formaterMoney(item.dayMoney).toString()" class="progress" />
            </van-cell>
          </div>
          <van-empty v-else description="暂无抖音客户消耗TOP情况" />
        </div>
        <!-- <div class="Statistics_title">
          <span>
            <van-tag type='primary' @click="clickCustSource(1)" color="#F4F5F7" text-color="#606060" :class="queryParams.custSource === 1?'tag-click':'tag-before'">直客</van-tag>
            <van-tag type='primary' @click="clickCustSource(2)" color="#F4F5F7" text-color="#606060" :class="queryParams.custSource === 2?'tag-click':'tag-before'">渠道</van-tag>
          </span>
          <span class="title_dis2">抖音客户消耗TOP情况-广州</span>
          <span @click="handleShow('gz')" style="color: #333;">{{ gzVisible?'收起':'展开' }}<van-icon :class="gzVisible?'query_icon_active':'query_icon'" size="12" name="play" /></span>
        </div>
        <van-tabs v-model="gzActiveTab" @change="gzTabChange">
          <van-tab :name="1" title="自运营"></van-tab>
          <van-tab :name="2" title="走量"></van-tab>
          <van-tab :name="3" title="收量"></van-tab>
        </van-tabs>
        <div class="vant-table">
          <div v-if="gzTopList.length > 0">
            <van-cell v-for="(item,index) in gzTopList" :key="index" @click="toDetails(item)">
              <span class="span_index" v-if="gzActiveTab === 1">{{ gzVisible? index + 1 : index === 4? amountPer.gzSelfConsumeList.length : index + 1 }}</span>
              <span class="span_index" v-if="gzActiveTab === 2">{{ gzVisible? index + 1 : index === 4? amountPer.gzTravelConsumeList.length : index + 1 }}</span>
              <span class="span_index" v-if="gzActiveTab === 3">{{ gzVisible? index + 1 : index === 4? amountPer.gzYieldConsumeList.length : index + 1 }}</span>
              <span class="line_wrap">{{ item.custName }}</span>
              <div class="riyue_box">
                <div>
                  <span class="span_label">日：</span>{{ formaterMoney(item.dayMoney) }}
                  <span :style="item.dayRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{ item.dayRatio }}%</span>
                </div>
                <div>
                  <span class="span_label">月：</span>{{ formaterMoney(item.moonMoney) }}
                  <span :style="item.moonRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{ item.moonRatio }}%</span>
                </div>
              </div>
              <van-progress :percentage="item.moneyRatio" :pivot-text="formaterMoney(item.dayMoney).toString()" class="progress" />
            </van-cell>
          </div>
          <van-empty v-else description="暂无广州抖音客户消耗TOP情况" />
        </div> -->
      </template>
      <div v-show="queryParams.isType === 1">
        <div class="Statistics_title">
          <span>
            <van-tag type='primary' @click="clickCustSource(1)" color="#F4F5F7" text-color="#606060" :class="queryParams.custSource === 1?'tag-click':'tag-before'">直客</van-tag>
            <van-tag type='primary' @click="clickCustSource(2)" color="#F4F5F7" text-color="#606060" :class="queryParams.custSource === 2?'tag-click':'tag-before'">渠道</van-tag>
          </span>
          <span class="title_dis2">腾讯客户消耗TOP情况</span>
          <span @click="handleShow('tencent')" style="color: #333;">{{ tencentVisible?'收起':'展开' }}<van-icon :class="tencentVisible?'query_icon_active':'query_icon'" size="12" name="play" /></span>
        </div>
        <div class="vant-table">
          <div v-if="tencentTopList.length > 0">
            <van-cell v-for="(item,index) in tencentTopList" :key="index" @click="toDetails(item)">
              <span class="span_index">{{ tencentVisible? index + 1 : index === 4? amountPer.tencentConsumeList.length : index + 1 }}</span>
              <span class="line_wrap">{{ item.custName }}</span>
              <div class="riyue_box">
                <div>
                  <span class="span_label">日：</span>{{ formaterMoney(item.dayMoney) }}
                  <span :style="item.dayRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{ item.dayRatio }}%</span>
                </div>
                <div>
                  <span class="span_label">月：</span>{{ formaterMoney(item.moonMoney) }}
                  <span :style="item.moonRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{ item.moonRatio }}%</span>
                </div>
              </div>
              <van-progress :percentage="item.moneyRatio" :pivot-text="formaterMoney(item.dayMoney).toString()" class="progress" />
            </van-cell>
          </div>
          <van-empty v-else description="暂无腾讯客户消耗TOP情况" />
        </div>
      </div>

    </div>
    <div class="radio_group">
      <van-button type="warning" block style="width: 60%;margin: 0 auto;border-radius: 10px;" @click="screenshot">生成报告</van-button>
    </div>

    <van-image-preview v-model="imageShow" :images="imageArr"></van-image-preview>
    <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :max-date="datePicker.maxDate" :type="datePicker.type" @confirm="datePickerConfirm" />
  </div>
</template>

<script>
import {
  Grid,
  GridItem,
  Popover,
  Calendar,
  Toast,
  ImagePreview
} from 'vant'
import statistics from '@/api/tongji/statistics'
import { formaterMoney } from '@/utils/util'
import * as echarts from 'echarts'
import html2canvas from 'html2canvas'

export default {
  name: 'TongjiIndex',
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Popover.name]: Popover,
    [Calendar.name]: Calendar,
    [Toast.name]: Toast,
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  props: {},
  data() {
    return {
      showFilterPop: false,
      showPopover1: false,
      showPopover2: false,
      offset: [100, 0],
      isNone: false,
      // activeNames: ['1'],
      // icon_title: require('../../assets/images/tj/ghicon.png'),
      showPopover: false,
      actions: [
        { text: '全部', value: 3 },
        { text: '腾讯', value: 1 },
        { text: '巨量', value: 2 }
        // { text: '快手KA', value: 4 },
        // { text: '快手大健康', value: 5 }
      ],
      activeType: '全部',
      queryParams: {
        deptId: null,
        startTime: null,
        endTime: null,
        isType: 3,
        isDay: 1,
        custSource: 1,
        dateStr: null
      },
      datePicker: {
        showDate: false,
        minDate: new Date(2023, 0, 1),
        maxDate: new Date(),
        type: 'single',
        formKey: ''
      },
      amountPer: {
        dayConsumeMoney: 0,
        moonConsumeMoney: 0,
        weekConsumeMoney: 0,
        dayConsumeRatio: 0,
        moonConsumeRatio: 0,
        weekConsumeRatio: 0,
        dayPaymentMoney: 0,
        moonPaymentMoney: 0,
        weekPaymentMoney: 0,
        dayPaymentRatio: 0,
        moonPaymentRatio: 0,
        weekPaymentRatio: 0,
        dayRechargeMoney: 0,
        moonRechargeMoney: 0,
        weekRechargeMoney: 0,
        dayRechargeRatio: 0,
        moonRechargeRatio: 0,
        weekRechargeRatio: 0
      },
      dateList: [],
      szyyList: [],
      szmjList: [],
      otherList: [],

      dyAdYieldList: [],
      dyAdTravelList: [],
      dyAdSelfList: [],
      dyQcYieldList: [],
      dyQcTravelList: [],
      dyQcSelfList: [],

      hnVisible: false,
      hnActiveTab: 1,
      hnTopList: [],

      gzVisible: false,
      gzActiveTab: 1,
      gzTopList: [],

      tencentVisible: false,
      tencentTopList: [],

      imageShow: false,
      imageArr: []
    }
  },
  computed: {},
  watch: {},
  created() {
    this.datePicker.minDate = new Date(this.getNextDate(-1).split('-')[0] - 1, 0, 1)
    this.queryParams.dateStr = this.getNextDate(-1)
  },
  async mounted() {
    this.init()
    await this.getStatistics()
  },
  methods: {
    async init() {
      // 修改主体框架标题
      document.title = '业绩消耗统计'
    },
    formatDateTime(date) {
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      return y + '-' + m + '-' + d
    },
    showTimePicker(type) {
      this.datePicker.formKey = type
      this.datePicker.showDate = true
    },
    async datePickerConfirm(date) {
      this.queryParams.dateStr = this.formatDateTime(date)
      this.datePicker.showDate = false
      await this.getStatistics()
    },
    // date 代表指定的日期，格式：2023-09-27
    // day 传-1表始前一天，传1表始后一天
    getNextDate(day) {
      var dd = new Date()
      dd.setDate(dd.getDate() + day)
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1
      var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate()
      return y + '-' + m + '-' + d
    },
    // 获取统计数
    async getStatistics() {
      this.hnVisible = false
      this.gzVisible = false
      this.tencentVisible = false
      await statistics.getDateMoneyRatio(this.queryParams).then(async res => {
        if (res.code === 200) {
          this.amountPer = res.data
          this.queryParams.isType = res.data.isType
          this.activeType = this.actions.find(item => { return item.value === res.data.isType }).text
          this.dateList = []
          this.szyyList = []
          this.szmjList = []
          this.otherList = []
          if (res.data.consumeDateList.length > 0) {
            const arr = res.data.consumeDateList
            arr.forEach(item => {
              this.dateList.push(item.dateStr)
              this.szyyList.push(item.marketingMoney)
              this.szmjList.push(item.mediumMoney)
              this.otherList.push(item.otherMoney)
            })
            await this.drawChart()
          }
          this.dyAdYieldList = []
          this.dyAdTravelList = []
          this.dyAdSelfList = []
          this.dyQcYieldList = []
          this.dyQcTravelList = []
          this.dyQcSelfList = []
          if (this.queryParams.isType === 2 && res.data.tagAdConsumeDateList.length > 0 && res.data.tagQcConsumeDateList.length > 0) {
            res.data.tagAdConsumeDateList.forEach(item => {
              this.dyAdYieldList.push(item.yieldMoney)
              this.dyAdTravelList.push(item.travelMoney)
              this.dyAdSelfList.push(item.selfMoney)
            })

            res.data.tagQcConsumeDateList.forEach(item => {
              this.dyQcYieldList.push(item.yieldMoney)
              this.dyQcTravelList.push(item.travelMoney)
              this.dyQcSelfList.push(item.selfMoney)
            })
            await this.drawChartDy()
          }
          if (this.queryParams.isType === 2) {
            if (res.data.hnSelfConsumeList.length > 5) {
              this.hnTopList = res.data.hnSelfConsumeList.slice(0, 4).concat(res.data.hnSelfConsumeList[res.data.hnSelfConsumeList.length - 1])
            } else {
              this.hnTopList = res.data.hnSelfConsumeList
            }
          }
          if (this.queryParams.isType === 2) {
            if (res.data.gzSelfConsumeList.length > 5) {
              this.gzTopList = res.data.gzSelfConsumeList.slice(0, 4).concat(res.data.gzSelfConsumeList[res.data.gzSelfConsumeList.length - 1])
            } else {
              this.gzTopList = res.data.gzSelfConsumeList
            }
          }
          if (this.queryParams.isType === 1) {
            if (res.data.tencentConsumeList.length > 5) {
              this.tencentTopList = res.data.tencentConsumeList.slice(0, 4).concat(res.data.tencentConsumeList[res.data.tencentConsumeList.length - 1])
            } else {
              this.tencentTopList = res.data.tencentConsumeList
            }
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    async onSelect(action) {
      this.queryParams.isType = action.value
      this.activeType = action.text
      await this.getStatistics()
    },
    async clickDay(id) {
      this.queryParams.isDay = id
      await this.getStatistics()
    },
    async clickCustSource(id) {
      this.queryParams.custSource = id
      await this.getStatistics()
    },
    drawChart() {
      var chartDom = document.getElementById('main01')
      var myChart = echarts.init(chartDom)
      var option
      const that = this
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            var htmlStr = '<div style="width: auto;height: auto;max-height: 240px;overflow-y: auto;"><p>' + params[0].axisValue + '</p>'
            var sum = 0
            for (var j = 0; j < params.length; j++) {
              sum += params[j].value
            }
            htmlStr += '<p style="color: #666;">全部：' + formaterMoney(sum) + '</p>'
            for (var i = 0; i < params.length; i++) {
              htmlStr += '<p style="color: #666;">' + params[i].marker + formaterMoney(params[i].value) + '<span style="margin-left: 5px;color: #07c160;">' + (sum == 0 ? 0 : (params[i].value / sum * 100).toFixed(2)) + '%</span></p>'
            }
            htmlStr += '</div>'
            return htmlStr
          }
        },
        legend: {
          data: ['数字运营', '数字媒介', '其它']
        },
        xAxis: [
          {
            type: 'category',
            data: that.dateList,
            axisLabel: {
              interval: 0,
              rotate: 40
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              inside: true
            },
            scale: true,
            min: 0, // 设置y轴最小值
            axisLabel: {
              margin: 2,
              formatter: function (value, index) {
                if (value >= 10000 && value < 10000000) {
                  value = value / 10000 + '万'
                } else if (value >= 10000000) {
                  value = value / 10000000 + '千万'
                }
                return value
              }
            }
          }
        ],
        grid: {
          left: 42
        },
        series: [
          {
            name: '数字运营',
            type: 'bar',
            stack: 'stack',
            emphasis: {
              focus: 'series'
            },
            data: that.szyyList
          },
          {
            name: '数字媒介',
            type: 'bar',
            stack: 'stack',
            emphasis: {
              focus: 'series'
            },
            data: that.szmjList
          },
          {
            name: '其它',
            type: 'bar',
            stack: 'stack',
            emphasis: {
              focus: 'series'
            },
            data: that.otherList
          }
        ]
      }
      option && myChart.setOption(option)
    },
    drawChartDy() {
      var myChartAd = echarts.init(document.getElementById('main02'))
      var myChartQc = echarts.init(document.getElementById('main03'))
      var option
      const that = this
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            var htmlStr = '<div style="width: auto;height: auto;max-height: 240px;overflow-y: auto;"><p>' + params[0].axisValue + '</p>'
            var sum = 0
            for (var j = 0; j < params.length; j++) {
              sum += params[j].value
            }
            htmlStr += '<p style="color: #666;">全部：' + formaterMoney(sum) + '</p>'
            for (var i = 0; i < params.length; i++) {
              htmlStr += '<p style="color: #666;">' + params[i].marker + formaterMoney(params[i].value) + '<span style="margin-left: 5px;color: #07c160;">' + (sum == 0 ? 0 : (params[i].value / sum * 100).toFixed(2)) + '%</span></p>'
            }
            htmlStr += '</div>'
            return htmlStr
          }
        },
        legend: {
          data: ['自运营', '走量', '收量']
        },
        xAxis: [
          {
            type: 'category',
            data: that.dateList,
            axisLabel: {
              interval: 0,
              rotate: 40
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              inside: true
            },
            scale: true,
            min: 0, // 设置y轴最小值
            axisLabel: {
              margin: 2,
              formatter: function (value, index) {
                if (value >= 10000 && value < 10000000) {
                  value = value / 10000 + '万'
                } else if (value >= 10000000) {
                  value = value / 10000000 + '千万'
                }
                return value
              }
            }
          }
        ],
        grid: {
          left: 42
        },
        series: [
          {
            name: '自运营',
            type: 'bar',
            stack: 'stack',
            emphasis: {
              focus: 'series'
            },
            data: that.dyAdSelfList
          },
          {
            name: '走量',
            type: 'bar',
            stack: 'stack',
            emphasis: {
              focus: 'series'
            },
            data: that.dyAdTravelList
          },
          {
            name: '收量',
            type: 'bar',
            stack: 'stack',
            emphasis: {
              focus: 'series'
            },
            data: that.dyAdYieldList
          }
        ]
      }
      const optionAd = { ...option }
      const optionQc = { ...option }
      optionQc.series = [
        {
          name: '自运营',
          type: 'bar',
          stack: 'stack',
          emphasis: {
            focus: 'series'
          },
          data: that.dyQcSelfList
        },
        {
          name: '走量',
          type: 'bar',
          stack: 'stack',
          emphasis: {
            focus: 'series'
          },
          data: that.dyQcTravelList
        },
        {
          name: '收量',
          type: 'bar',
          stack: 'stack',
          emphasis: {
            focus: 'series'
          },
          data: that.dyQcYieldList
        }
      ]
      optionAd && myChartAd.setOption(optionAd)

      optionQc && myChartQc.setOption(optionQc)
    },
    hnTabChange(tab, event) {
      if (tab === 1) {
        if (this.hnVisible || this.amountPer.hnSelfConsumeList.length < 5) {
          this.hnTopList = this.amountPer.hnSelfConsumeList
        } else {
          this.hnTopList = this.amountPer.hnSelfConsumeList.slice(0, 4).concat(this.amountPer.hnSelfConsumeList[this.amountPer.hnSelfConsumeList.length - 1])
        }
      } else if (tab === 2) {
        if (this.hnVisible || this.amountPer.hnTravelConsumeList.length < 5) {
          this.hnTopList = this.amountPer.hnTravelConsumeList
        } else {
          this.hnTopList = this.amountPer.hnTravelConsumeList.slice(0, 4).concat(this.amountPer.hnTravelConsumeList[this.amountPer.hnTravelConsumeList.length - 1])
        }
      } else if (tab === 3) {
        if (this.hnVisible || this.amountPer.hnYieldConsumeList.length < 5) {
          this.hnTopList = this.amountPer.hnYieldConsumeList
        } else {
          this.hnTopList = this.amountPer.hnYieldConsumeList.slice(0, 4).concat(this.amountPer.hnYieldConsumeList[this.amountPer.hnYieldConsumeList.length - 1])
        }
      }
    },
    gzTabChange(tab, event) {
      if (tab === 1) {
        if (this.gzVisible || this.amountPer.gzSelfConsumeList.length < 5) {
          this.gzTopList = this.amountPer.gzSelfConsumeList
        } else {
          this.gzTopList = this.amountPer.gzSelfConsumeList.slice(0, 4).concat(this.amountPer.gzSelfConsumeList[this.amountPer.gzSelfConsumeList.length - 1])
        }
      } else if (tab === 2) {
        if (this.gzVisible || this.amountPer.gzTravelConsumeList.length < 5) {
          this.gzTopList = this.amountPer.gzTravelConsumeList
        } else {
          this.gzTopList = this.amountPer.gzTravelConsumeList.slice(0, 4).concat(this.amountPer.gzTravelConsumeList[this.amountPer.gzTravelConsumeList.length - 1])
        }
      } else if (tab === 3) {
        if (this.gzVisible || this.amountPer.gzYieldConsumeList.length < 5) {
          this.gzTopList = this.amountPer.gzYieldConsumeList
        } else {
          this.gzTopList = this.amountPer.gzYieldConsumeList.slice(0, 4).concat(this.amountPer.gzYieldConsumeList[this.amountPer.gzYieldConsumeList.length - 1])
        }
      }
    },
    handleShow(type) {
      this[type + 'Visible'] = !this[type + 'Visible']
      if (type === 'hn' || type === 'gz') {
        if (this[type + 'ActiveTab'] === 1) {
          if (this[type + 'Visible'] || this.amountPer[type + 'SelfConsumeList'].length < 5) {
            this[type + 'TopList'] = this.amountPer[type + 'SelfConsumeList']
          } else {
            this[type + 'TopList'] = this.amountPer[type + 'SelfConsumeList'].slice(0, 4).concat(this.amountPer[type + 'SelfConsumeList'][this.amountPer[type + 'SelfConsumeList'].length - 1])
          }
        } else if (this[type + 'ActiveTab'] === 2) {
          if (this[type + 'Visible'] || this.amountPer[type + 'TravelConsumeList'].length < 5) {
            this[type + 'TopList'] = this.amountPer[type + 'TravelConsumeList']
          } else {
            this[type + 'TopList'] = this.amountPer[type + 'TravelConsumeList'].slice(0, 4).concat(this.amountPer[type + 'TravelConsumeList'][this.amountPer[type + 'TravelConsumeList'].length - 1])
          }
        } else if (this[type + 'ActiveTab'] === 3) {
          if (this[type + 'Visible'] || this.amountPer[type + 'YieldConsumeList'].length < 5) {
            this[type + 'TopList'] = this.amountPer[type + 'YieldConsumeList']
          } else {
            this[type + 'TopList'] = this.amountPer[type + 'YieldConsumeList'].slice(0, 4).concat(this.amountPer[type + 'YieldConsumeList'][this.amountPer[type + 'YieldConsumeList'].length - 1])
          }
        }
      } else if (type === 'tencent') {
        if (this[type + 'Visible'] || this.amountPer.tencentConsumeList.length < 5) {
          this.tencentTopList = this.amountPer.tencentConsumeList
        } else {
          this.tencentTopList = this.amountPer.tencentConsumeList.slice(0, 4).concat(this.amountPer.tencentConsumeList[this.amountPer.tencentConsumeList.length - 1])
        }
      }
    },
    toDetails(item) {
      this.$router.push({
        path: '/cont/approve/detail',
        query: { id: item.contractId }
      })
    },
    screenshot() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '生成报告中...'
      })
      html2canvas(document.querySelector('#reportImage'), {
        allowTaint: false, // 允许污染
        taintTest: true, // 在渲染前测试图片(没整明白有啥用)
        useCORS: true, // 使用跨域(当allowTaint为true时这段代码没什么用)
        background: '#fff'
        // width: 375,          //截图宽度
        // height: 500,         //截图高度
        // y: 100               //y偏移量  从截图元素顶部多少像素开始截图
        // x:100                 //x偏移量
      }).then((image) => {
        const url = image.toDataURL('image/png', 1.0)
        Toast.clear()
        this.imageShow = true
        this.imageArr = []
        this.imageArr.push(url)
        // const link = document.createElement('a')
        // link.href = url
        // link.setAttribute('download', '业绩消耗统计.png')
        // link.style.display = 'none'
        // document.body.appendChild(link)
        // link.click()
      })
    }
  }
}
</script>

<style scoped lang='less'>
@import url("@/style/index.less");
.placeholder{
  width: 80px;
}
.query_type{
  text-decoration: underline;
  font-size: 0.5rem;
  color: #1E90FF;
  font-weight: bold;
}
.query_time{
  margin-left: -60px;
  margin-top: 20px;
  font-size: 40px;
  font-weight: bold;
  color: #1E90FF;
}
.query_icon{
  margin-left: 10px;
}
.query_icon_active{
  margin-left: 10px;
  transform: rotate(90deg);
}
.top_box{
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 20px;
}
.tag-click{
  border: 0.02667rem solid #1E90FF !important;
  color:#fff !important;
  background-color: #1E90FF !important;
}
.tag-before{
  border: 0.02667rem solid #999999 !important;
  background-color: #fff !important;
}

.sectionList {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  /deep/.van-grid-item__content{
    padding: 20px;
  }
  .describe{
    position: absolute;
    top: 10px;
    left: 10px;
  }
  .describe2{
    position: absolute;
    top: 10px;
    right: 10px;
    color: #b4b4b4;
    font-size: 24px;
  }
  .th_box{
    padding-top: 10px;
    // padding-bottom: 30px;
    width: 100%;
    .center {
      width: 100%;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      // margin-top: 20px;
      .Statistics_num {
        font-size: 30px;
        font-weight: bold;
        color: #0000FF;
        margin-left: 20px;
        margin-right: 20px;
      }
      .Statistics_name{
        margin-top: 20px;
        font-size: 26px;
        color: #87CEFA;
        font-weight: bold;
      }
      .percent{
        // display: flex;
        // justify-content: flex-end;
        width: 50%;
        text-align: right;
      }
      .percentage{
        font-size: 16px !important;
      }
    }
    .S_num {
      width: 100%;
      font-size: 32px;
      font-weight: bold;
      color: #0000FF;
      // text-align: center;
      padding: 10px 0 0 10px;
      // margin-left: 20px;
      // margin-right: 20px;
    }
    .S_num_xh{
      font-size: 36px;
    }
    .center_first{
      margin: 0 auto;
      width: 70%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .Statistics_num {
        font-size: 30px;
        font-weight: bold;
        color: #0000FF;
      }
      .Statistics_name{
        width: 28%;
        margin-top: 10px;
        font-size: 26px;
        color: #87CEFA;
        font-weight: bold;
      }
      .percent{
        // display: flex;
        // justify-content: flex-end;
        width: 30%;
        text-align: right;
      }
      .percentage{
        font-size: 16px !important;
      }
    }
  }
}
// .rrr{
//   height: 100px;
// }
.Statistics_title{
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  font-size: 30px;
  color:#87CEFA;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.radio_group{
  background-color: #fff;
  margin-top: 10px;
  padding: 40px 0 160px 0;
}
.none{
  background-color: #fff;
  margin-top: 10px;
  height: 660px;
}
.contTip{
  padding: 20px;
  width: 600px;
  font-size: 16px;
  color: #333;
}
#main01{
  width: 100%;
  height: 700px;
  background-color: #fff;
  margin-top: 10px;
  padding-bottom: 12px;
}
#main02{
  width: 100%;
  height: 700px;
  background-color: #fff;
  margin-top: 10px;
  padding-bottom: 12px;
}
#main03{
  width: 100%;
  height: 700px;
  background-color: #fff;
  margin-top: 10px;
  padding-bottom: 12px;
}

/deep/.van-tabs{
  background-color: #fff;
}
/deep/.van-tabs__line{
  position: absolute;
  bottom: 0.4rem;
  left: 0;
  z-index: 1;
  width: 1.06667rem;
  height: 0.08rem;
  background-color: #1989fa;
  border-radius: 0.08rem;
}
/deep/.van-tab--active{
  color: #87CEFA;
}
/deep/.van-tab__text{
  font-size: 24px;
  font-weight: bold;
}
.vant-table{
  background-color: #fff;
  line-height: 50px;
  font-size: 28px;
  color: #666;
  .span_index{
    display: inline-block;
    width: 50px;
  }
  .riyue_box{
    margin-left: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .span_label{
    color: #b4b4b4;
  }
  .line_wrap{
    width: 93%;
    margin-left: -10px;
    display: inline-block;
    padding-left: 0px;
    text-indent: -0px;
  }
  .progress{
    width: 94%;
    margin: 20px 0 20px 40px;
  }
}
</style>
